import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/context/AuthContext';
import { PlayerProvider } from '@/context/PlayerContext';
import { Layout } from '@/components/layout/Layout';
import { ProtectedRoute } from '@/components/ProtectedRoute';

import Home from '@/pages/Home';
import Create from '@/pages/Create';
import Studio from '@/pages/Studio';
import StudioProject from '@/pages/StudioProject';
import Library from '@/pages/Library';
import Credits from '@/pages/Credits';
import Challenges from '@/pages/Challenges';
import ChallengeDetail from '@/pages/ChallengeDetail';
import Hits from '@/pages/Hits';
import PublicSong from '@/pages/PublicSong';
import Account from '@/pages/Account';
import Admin from '@/pages/Admin';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import AuthCallback from '@/pages/AuthCallback';
import Landing from '@/pages/Landing';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import Terms from '@/pages/Terms';
import DeleteAccount from '@/pages/DeleteAccount';

function App() {
  return (
    <AuthProvider>
      <PlayerProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/app" element={<Home />} />
              <Route path="/create" element={<Create />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/studio/:projectId" element={<StudioProject />} />
              <Route path="/library" element={<Library />} />
              <Route path="/credits" element={<Credits />} />
              <Route path="/challenges" element={<Challenges />} />
              <Route path="/challenges/:slug" element={<ChallengeDetail />} />
              <Route path="/hits" element={<Hits />} />
              <Route path="/account" element={<Account />} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            </Route>
            <Route path="/song/:slug" element={<PublicSong />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/" element={<Landing />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors closeButton />
      </PlayerProvider>
    </AuthProvider>
  );
}

export default App;
